import { render, staticRenderFns } from "./LiveParams.vue?vue&type=template&id=67045d75&scoped=true&"
import script from "./LiveParams.vue?vue&type=script&lang=js&"
export * from "./LiveParams.vue?vue&type=script&lang=js&"
import style0 from "./LiveParams.vue?vue&type=style&index=0&id=67045d75&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67045d75",
  null
  
)

export default component.exports